// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080435/js/" + chunkId + "." + {"44":"56a30822","225":"64d64347","481":"6a508fa3","486":"bed56879","770":"4066a86a"}[chunkId] + ".0.31567145630417304.chunk.js";
};